import { ChangelogEntry } from './changelog.entities';

export const filterChangelogEntries = (
  entries: ChangelogEntry[],
  isFederatedUser: boolean,
): ChangelogEntry[] =>
  entries.filter((entry) => !entry.federatedOnly || isFederatedUser);
